import { Fragment } from "react";
import { Link } from "react-router-dom";
import {
  isPolicyInactiveByPolicyStatus,
  isAllowedToMakeCCPayment,
} from "js/utilities";
import { useAuthorizationCheck } from "hooks/useAuthorizationCheck";

const ThingsYouCanDoCard = ({
  data,
  policy,
  hasDirectBillDocuments = false,
}) => {
  let viewServiceandClaim = useAuthorizationCheck(4);
  let viewPayments = useAuthorizationCheck(3);

  const simpleListLink = (category, link) => (
    <li
      className="mb-2"
      key={`things you can do - ${category.heading} - ${link.name}`}
    >
      {link.name === "Update Payment Frequency" ||
      link.name === "Make a Payment" ? (
        <>
          <Link to={`${link.route}/${policy?.contractID}`}>{link.name}</Link>
        </>
      ) : (
        <>
          <Link to={link.route}>{link.name}</Link>
        </>
      )}
    </li>
  );

  return (
    <div className="ui-card mb-4 md:mb-6">
      <div className="px-4 pt-4 pb-1 border-b border-theme-rule-light">
        <h2 className="text-sm font-body font-semibold">Things You Can Do</h2>
      </div>
      <div className="p-4">
        <div className="grid gap-4 grid-flow-dense sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-1">
          {data.map((category) => (
            <div key={`things you can do - ${category.heading}`}>
              <div className="font-semibold mb-2">{category.heading}</div>
              <ul className="ml-2 text-sm">
                {category.links.map((link) => {
                  if (category.heading === "Transactions") {
                    if (!viewPayments) return <></>;

                    if (
                      isPolicyInactiveByPolicyStatus(policy?.status) &&
                      (link.name === "Make a Payment" ||
                        link.name === "Update Payment Frequency")
                    )
                      return <></>;
                    if (link.name === "View Premium Notice") {
                      return hasDirectBillDocuments ? (
                        <li
                          className="mb-2"
                          key={`things you can do - ${category.heading} - ${link.name}`}
                        >
                          <Link
                            to={`${link.route}?contractId=${policy?.oldPolicy}&category=PREMIUM NOTICE`}
                          >
                            {link.name}
                          </Link>
                        </li>
                      ) : (
                        <></>
                      );
                    }

                    if (link.name === "Make a Payment") {
                      if (["LQ", "LZ", "AVD"].includes(policy?.product?.type)) {
                        return <></>;
                      }
                      return isAllowedToMakeCCPayment(
                        policy,
                        "onetimepayment"
                      ) ? (
                        simpleListLink(category, link)
                      ) : (
                        <Fragment
                          key={`things you can do - ${category.heading} - ${link.name}`}
                        />
                      );
                    } else {
                      return simpleListLink(category, link);
                    }
                  }

                  if (category.heading === "Manage Contract") {
                    if (!viewServiceandClaim) return <></>;
                    if (link.name === "View All Forms") {
                      return (
                        <li
                          className="mb-2"
                          key={`things you can do - ${category.heading} - ${link.name}`}
                        >
                          <Link
                            to={`${link.route}?contractId=${policy?.oldPolicy}`}
                          >
                            {link.name}
                          </Link>
                        </li>
                      );
                    } else if (link.name === "Beneficiary Change Form") {
                      return (
                        <li
                          className="mb-2"
                          key={`things you can do - ${category.heading} - ${link.name}`}
                        >
                          <Link
                            to={`${link.route}?contractId=${policy?.oldPolicy}&keyword=Change of Beneficiary`}
                          >
                            {link.name}
                          </Link>
                        </li>
                      );
                    } else if (link.name === "Update Contact Information") {
                      if (["LQ", "LZ", "AVD"].includes(policy?.product?.type)) {
                        return (
                          <li
                            className="mb-2"
                            key={`things you can do - ${category.heading} - ${link.name}`}
                          >
                            <Link
                              to={`/services-claims/forms?keyword=address&contractId=${policy?.oldPolicy}`}
                            >
                              {link.name}
                            </Link>
                          </li>
                        );
                      } else {
                        return simpleListLink(category, link);
                      }
                    } else if (link.name === "Fund Transfers") {
                      if (["LQ", "LZ", "AVD"].includes(policy?.product?.type)) {
                        return (
                          <li
                            className="mb-2"
                            key={`things you can do - ${category.heading} - ${link.name}`}
                          >
                            <Link
                              to={`${link.route}?contractId=${policy?.oldPolicy}&keyword=fund transfer`}
                            >
                              {link.name}
                            </Link>
                          </li>
                        );
                      } else {
                        return null;
                      }
                    } else if (
                      link.name ===
                      "Fund Performance, Prospectuses & Fund Information"
                    ) {
                      if (policy?.product?.type === "AVD") {
                        return (
                          <li
                            className="mb-2"
                            key={`things you can do - ${category.heading} - ${link.name}`}
                          >
                            <a
                              href="https://www.everlakelife.com/policies-contracts/annuities/variable-annuities/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {link.name}
                            </a>
                          </li>
                        );
                      } else if (
                        policy?.product?.type === "LQ" ||
                        policy?.product?.type === "LZ"
                      ) {
                        return (
                          <li
                            className="mb-2"
                            key={`things you can do - ${category.heading} - ${link.name}`}
                          >
                            <a
                              href="https://www.everlakelife.com/policies-contracts/life-insurance/variable-universal-life-insurance/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {link.name}
                            </a>
                          </li>
                        );
                      } else {
                        return null;
                      }
                    }
                  }
                })}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ThingsYouCanDoCard;
